import { Navigate } from "react-router-dom";
import { STORAGE_KEYS } from "../utils/constants/storageKeys";

/**
 * PrivateRoute component to protect routes based on authentication and role.
 *
 * @param {Object} props
 * @param {JSX.Element} props.element - Component to render if authorized.
 * @param {string} [props.requiredRole] - Optional role required to access.
 * @param {string} [props.fallbackPath="/"] - Redirect path if unauthorized.
 * @returns {JSX.Element}
 */
const PrivateRoute = ({ element, requiredRole, fallbackPath = "/" }) => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN) || sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  const storedRole = localStorage.getItem(STORAGE_KEYS.ROLE) || sessionStorage.getItem(STORAGE_KEYS.ROLE);
  const allowed = token && (!requiredRole || storedRole === requiredRole);

  return allowed ? element : <Navigate to={token ? fallbackPath : "/"} replace />;
};

export default PrivateRoute;
